module.exports = __webpack_public_path__ + "img/eye-dropper.5b039841.svg";